// extracted by mini-css-extract-plugin
export var subtitle = "_bd-2";
export var title = "_bd-0";
export var titleNoWrap = "_bd-1";